import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { classNames } from 'primereact/utils'
import { Password } from "primereact/password"
import { InputText } from 'primereact/inputtext'
import { Link, useNavigate } from 'react-router-dom'
import server from 'infra/server'
import { getMessagesFromError } from 'helper/error'
import { Message } from 'primereact/message'
import { InputOtp } from 'primereact/inputotp'

export default function RedefinirSenha() {

    const [message, setMessage] = useState({})
    const navigate = useNavigate()
    const toast = useRef(null)
    const [token, setToken] = useState()
    const [enviar, setEnviar] = useState({ icon: '', label: 'Enviar código para o e-mail', outlined: true, text: false })

    const defaultValues = {
        email: '',
        passwordNew: '',
        passwordRepeat: '',
        code: ''
    }

    const form = useForm({ defaultValues })
    const errors = form.formState.errors
    const toastIf = (expression, detail) => {
        if (expression) {
            toast.current.show({ severity: 'error', summary: 'Ops!', detail })
            return true
        }
        return false
    }

    const [loading, setLoading] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768 || window.innerHeight < 420)

    useEffect(() => {
        document.body.style.backgroundColor = '#ffffff'
        return () => {
            document.body.style.backgroundColor = ''
        }
    }, [])

    const onSubmit = (data) => {
    }

    const btnEnviarCodigoOnClick = (data) => {

        setLoading(true)

        setMessage({})

        const post = { email: data.email }

        server().post('resetpwdsendcode', post).then((response) => {

            setMessage({ severity: 'success', message: 'Código enviado para o e-mail' })

            const newEnviar = { ...enviar }
            newEnviar.icon = 'pi pi-check'
            newEnviar.label = 'Código enviado!'
            newEnviar.text = true
            setEnviar(newEnviar)

            setTimeout(() => {
                const newEnviar = { ...enviar }
                newEnviar.icon = ''
                newEnviar.label = 'Reenviar código!'
                newEnviar.text = false
                setEnviar(newEnviar)
                message.message = ''
                setMessage(message)
            }, 10000)

        }).catch(err => {
            toast.current.clear()
            const message = getMessagesFromError({ err, alt: 'Erro desconhecido ao enviar código!' })
            setMessage({ severity: 'error', message })
        }).finally(() => {
            setLoading(false)
        })

    }

    const btnConfirmarOnClick = (data) => {

        setMessage({})

        if (toastIf(data.passwordNew.length < 5, 'Senha muito curta')) {
        } else if (toastIf(data.passwordNew !== data.passwordRepeat, 'As senhas devem ser iguais')) {
        } else {

            const post = { email: data.email, password: data.passwordNew, code: token }

            server().post('resetpwdconfirm', post).then((response) => {

                console.log("Resposta:", response)
                setMessage({ severity: 'success', message: response.data })

            }).catch(err => {
                toast.current.clear()
                const message = getMessagesFromError({ err, alt: 'Erro desconhecido ao confirmar código!' })
                setMessage({ severity: 'error', message })
            })

        }

    }

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error"></small>
    }

    return (
        <div className="flex flex-column md:flex-row bg-white h-screen">

            {/* Esquerda: Branding */}
            {isMobile ? (
                <></>
            ) : (
                < div className="md:w-6 border-0" >
                    <img src="/login-sup-esq.svg" className='border-0' alt="Arte superior esquerda" />
                    <div className='flex border-0 absolute' style={{ top: '50%', left: '25%' }}>
                        <img src="/logo.svg" className='' alt="Logo" style={{ width: '15%' }} />
                        <div>
                            <div className='text-7xl ml-4'>Fiz Aqui</div>
                            <div className='ml-5 mt-1 text-gray-400'>Enterprise Resource Planning</div>
                        </div>
                    </div>
                </div>
            )}

            {/* Direita: Formulário */}
            <div className={`border-0 w-full md:w-${isMobile ? 12 : 6} flex flex-column align-items-center z-1`}>

                {/* Cabeçalho */}
                <div className="border-0 pb-8 border-green-500 p-0 w-full flex flex-column align-items-end relative">

                    <img className="absolute" src="/login-sup-dir.svg" alt="Arte superior direira" />
                    <div className="absolute flex flex-nowrap mt-2 mr-4 ext-white text-lg">
                        <Link id='redefinePassword' to="/redefinirsenha" className="text-white no-underline">Esqueci minha senha</Link>
                        <div className='mx-2 text-white'>|</div>
                        <Link id='addExtraBase' to="/adicionabaseextra" className="text-white no-underline">Adicionar base</Link>
                    </div>

                </div>
                {/* Formulário */}
                <div className="border-0 border-round h-full w-full flex flex-column align-items-center justify-content-center">
                    <div className='flex flex-column border-0 shadow-0 justify-content-center align-items-center border-round-2xl bg-white w-20rem'>

                        <Toast ref={toast} />
                        <h2 className="flex flex-row justify-content-start align-items-center text-900 mb-4">
                            <img src="/logo.svg" className='' alt="Logo" style={{ width: '9%' }} />
                            <div className='ml-2 font-light'>Redefinir senha</div>
                        </h2>

                        <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-column align-items-left gap-2">

                            <Controller
                                name="email"
                                control={form.control}
                                rules={{ required: 'email' }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.email })}>
                                        </label>
                                        <InputText
                                            id={field.name}
                                            {...field}
                                            placeholder='E-mail'
                                            inputMode="email"
                                            className={classNames("flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2", { 'p-invalid': fieldState.error })}
                                            autoComplete="on"
                                        />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                            <Controller
                                name="passwordNew"
                                control={form.control}
                                rules={{ required: 'A senha é obrigatória' }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.password })}></label>
                                        <Password
                                            inputId={field.name}
                                            {...field}
                                            placeholder='Senha'
                                            inputClassName="flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2"
                                            className={classNames("", { 'p-invalid': fieldState.error })}
                                            feedback={true}
                                            toggleMask={true}
                                            promptLabel="Informe sua senha"
                                            weakLabel="Tá indo bem..."
                                            mediumLabel="Médio"
                                            strongLabel="Essa é boa!"
                                            autoComplete="on"
                                            pt={{ showIcon: { className: 'mr-2' }, hideIcon: { className: 'mr-2' } }}
                                        />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                            <Controller
                                name="passwordRepeat"
                                control={form.control}
                                rules={{ required: 'A senha é obrigatória' }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.password })}></label>
                                        <Password inputId={field.name} {...field} placeholder='Repita a senha'
                                            inputClassName="flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2"
                                            className={classNames("", { 'p-invalid': fieldState.error })}
                                            feedback={false}
                                            toggleMask={true}
                                            autoComplete="off"
                                            pt={{ showIcon: { className: 'mr-2' }, hideIcon: { className: 'mr-2' } }}
                                        />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />

                            <Button id='sendCode' label={enviar.label}
                                className='w-min white-space-nowrap text-sm mb-2 border-2 border-solid border-logo-main border-round-2xl pr-3 bg-logo-main text-white'
                                type="submit" icon={enviar.icon} onClick={form.handleSubmit(btnEnviarCodigoOnClick)} outlined={enviar.outlined} text={enviar.text}
                            />

                            <>
                                <label htmlFor={'code'} className={classNames("text-logo-main", { 'p-error': errors.code })} >Código</label>
                                <InputOtp inputId={'code'} className='' value={token} onChange={(e) => setToken(e.value)} integerOnly length={6} />

                            </>

                            {/* Botão */}
                            <Button label="Confirmar" type="submit" icon={loading ? "pi pi-spin pi-cog" : ""}
                                className="w-full font-bold bg-logo-main border-logo-main line-height-4 text-white border-2 border-solid border-round-2xl mt-2"
                                onClick={form.handleSubmit(btnConfirmarOnClick)}
                            />

                            {/* Links adicionais */}
                            <div className="text-right mt-4">
                                <Link id='login' to="/login" className="text-logo-main no-underline">Login</Link>
                            </div>

                            {message.message &&
                                <Message className="text-sm w-13rem mt-2" style={{ fontStyle: 'italic' }} severity={message.severity} text={message.message} />
                            }

                        </form>

                    </div>

                </div>

            </div>

        </div>
    )
}
